const saveHandlers = new WeakMap<HTMLFormElement, () => Promise<void>>();

export const onFormSave = (form: HTMLFormElement, handler: () => Promise<void>) => {
  saveHandlers.set(form, handler);
};

export const saveForm = async (form: HTMLFormElement) => {
  await saveHandlers.get(form)?.();
};

export const lockSavedForm = (form: HTMLFormElement, redirecting: boolean) => {
  if (redirecting || window.parent !== window) {
    form.dataset.submitted = 'true';
  }
};
